import React, { Component } from 'react';
import { Field, reduxForm} from 'redux-form';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { phonePattern } from '@/utils/forms.js';
import api, { setErrors} from '@/middlewares/api';

import FormField from '@/components/forms/form-field';
import Loader from '@/components/loader';

class ProfilePersonalForm extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(data) {
        //console.log(data);              
        return new Promise((resolve, reject) => {
            api.post('profile/personal', data)
            .then((response) => {
                //console.log('res', response.data);
                this.props.updateUserData(response.data.data, 'profile');
                toast.success('Personal details saved successfully.');
                return resolve(null);
            })
            .catch((err) => {
                console.log(err);
                if(! err.response) {
                    toast.error('Network error. Please check your connection and try again.');
                    return reject({ _error: 'Network error. Please check your connection and try again.' });
                }
                if(err.response.status === 422) {
                    toast.error('Please fix the highlighted fields and try again.');
                    return reject(setErrors(err.response));
                }
                const message = err.response.data?.message || 'Could not save changes. Please try again.';
                toast.error(message);
                return reject({ _error: message });
            })
        }); 
    }
    
    render() {
        const { handleSubmit, submitting, error } = this.props;
        return (
            <React.Fragment>
            <Loader isOpen={ submitting } type="full" />
            <form
                onSubmit={handleSubmit((data) => {
                return this.handleFormSubmit(data);
            }) } className="profile-form"
            noValidate>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className="form-row">
                <div className="form-col_2">
                    <Field                            
                        name="first_name"
                        component={FormField}                                        
                        type="text"
                        
                        placeholder="Your First Name"
                        label="First Name"                            
                    />                    
                </div>                                
                <div className="form-col_2">                    
                    <Field                            
                        name="last_name"
                        component={FormField}                                        
                        type="text"
                        placeholder="Your Last Name"
                        label="Last Name"                            
                    />               
                </div>
            </div>
            <div className="form-row">
                {/*<div className="form-col_2">
                    <Field
                        name="personal_email"
                        component={FormField}
                        type="text"
                        placeholder="some@email.com"
                        label="Your Email Address"
                    />
                </div>      */}
                <div className="form-col_2">
                    <Field
                        name="personal_phone"
                        component={FormField}
                        {...phonePattern}
                        type="text"
                        label="Your Phone Number"
                        note="E.g. (XXX) XXX–XXXX"
                    />

                </div>
            </div>            
            <div className="submit-row">
                <button className="btn btn-primary" disabled={ submitting }
                        type="submit">Save Changes</button>

            </div>
        </form>
        </React.Fragment>
        )
    }
}
const ProfilePersonalFormWrapped =  reduxForm({
    form: 'dashboard-profile-personal-form',
    enableReinitialize: true,

  })(ProfilePersonalForm);

ProfilePersonalFormWrapped.propTypes = {
    //...RFPropsTypes,
    updateUserData: PropTypes.func.isRequired,
}  

export default ProfilePersonalFormWrapped;
